export class Accordeon {
  constructor(container) {
    this._elem = document.querySelector(container);
    this._elemClickHandler = this._elemClickHandler.bind(this);

    if (this._elem === null) {
      return;
    }
    this._elem.addEventListener('click', this._elemClickHandler);
  }

  _elemClickHandler(evt) {
    const classes = Array.from(evt.target.classList);
    if (classes.some(it => it.includes('__title'))) {
      const parent = evt.target.parentNode;
      parent.classList.toggle('active');
    }
  }
}
